import { Label, Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { ChooseAmountInputWithSlider } from '../../../../../../../ui/ChooseAmountInputWithSlider/ChooseAmountInputWithSlider';

export const ChooseAmount = ({
    selectedAmount,
    onChange,
    maxAmount
}: {
    selectedAmount: number;
    onChange: (
        amount: number,
        event: React.ChangeEvent<HTMLInputElement>
    ) => void;
    maxAmount: number;
}) => (
    <div
        className="space-y-xl px-l min-sm:px-xl"
        data-testid="choose-amount-section"
    >
        <Text className="text-2xl font-bold">
            <FormattedMessage
                id="_.flexi_approved.title"
                defaultMessage="Let’s make your first withdrawal"
            />
        </Text>
        <ChooseAmountInputWithSlider
            label={
                <Label htmlFor="choose-amount">
                    <FormattedMessage
                        id="_.flexi_approved.label"
                        defaultMessage="How much would you like to withdraw today?"
                    />
                </Label>
            }
            selectedAmount={selectedAmount}
            onChange={onChange}
            maxAmount={maxAmount}
        />
    </div>
);
